import React, { FC } from 'react';
import { useAuthContext } from '@raisin/cp-layout';
import { MediaTile as UIMediaTile, MediaTileDataProps } from '@raisin/components-lib';
import { onMediaTileCtaClicked } from 'eventsTracking';

export type MediaTileProps = Omit<MediaTileDataProps, 'onCtaClick'>;

export const MediaTile: FC<MediaTileProps> = (props) => {
  const { isLoggedIn } = useAuthContext();
  const onCtaClick = (id: string, event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    const cta = props.ctas.find(({ _metadata: { uid } }) => uid === id);
    if (!cta) {
      return;
    }
    const targetUrl = cta.inner_page?.at(0)?.url || cta.external_url;
    if (!targetUrl) {
      return;
    }
    return onMediaTileCtaClicked({
      isLoggedIn,
      targetUrl,
      pageUrl: window.location.href,
      type: cta.select_cta_type === 'primary' ? 'primary_CTA' : 'secondary_CTA',
      event,
    });
  };
  return <UIMediaTile {...props} onCtaClick={onCtaClick} />;
};
